import { render, staticRenderFns } from "./ArticleWrite.vue?vue&type=template&id=96e7f31e&scoped=true&"
import script from "./ArticleWrite.vue?vue&type=script&lang=js&"
export * from "./ArticleWrite.vue?vue&type=script&lang=js&"
import style0 from "./ArticleWrite.vue?vue&type=style&index=0&id=96e7f31e&prod&lang=scss&"
import style1 from "./ArticleWrite.vue?vue&type=style&index=1&id=96e7f31e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e7f31e",
  null
  
)

export default component.exports